import { objectToURLQueryParams } from '@common/helpers/url';
import { getModalFromEntry } from '@common/helpers/wizard';
import { isBrowser } from 'sly/config';

export default function redirectToHomebase(communityName, mode) {
  if (mode) {
    const qp = {};
    const modal = getModalFromEntry(mode.entry);
    if (modal) {
      qp.modal = modal;
    }
    if (communityName) {
      qp.communityName = communityName;
    }

    const redirectPath = `/homebase?${objectToURLQueryParams(qp)}`;

    if (isBrowser) {
      window.location.assign(redirectPath);
    }
  }
}
